import React from 'react'
import DisplayConditionNode from '../components/DisplayConditionNode'

export default ({ node }) => (
  <DisplayConditionNode
    field={node.extras.variable}
    operator={node.extras.operator}
    value={node.extras.value}
  />
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactDataIs/ContactDataIsDisplay.jsx